import { render, staticRenderFns } from "./SimulatedImage.vue?vue&type=template&id=5cb0bc76&scoped=true&"
import script from "./SimulatedImage.vue?vue&type=script&lang=js&"
export * from "./SimulatedImage.vue?vue&type=script&lang=js&"
import style0 from "./SimulatedImage.vue?vue&type=style&index=0&id=5cb0bc76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb0bc76",
  null
  
)

export default component.exports